import type {
  ComparisonDataResponse,
  FetchComparisonDataParams,
} from '@dc-shared-web/hooks/api/comparison/types'
import { AxiosInstance } from 'axios'

export const fetchComparisonData = async (
  apiClient: AxiosInstance,
  params: FetchComparisonDataParams
): Promise<ComparisonDataResponse> => {
  const { data } = await apiClient.get<ComparisonDataResponse>('/v1/compare', {
    params: {
      ...params,
    },
  })

  return data
}
